<template>
     <div>
      <h1>{{ $t('help.ISABedExitHelp_title') }}</h1>
      <p class="text-justify">
          {{ $t('The Bed Exit feature detects when a patient leaves his bed. When Bed Exit feature is enabled, it allows medical staff to activate or desactivate and schedule detection hours for specific sensors in the current care unit.') }}'
      </p>
      
    </div>
</template>

<script>

export default  {
  components: {    
  },  
  data() {
    return {      
    }
  },
  watch : {    
  },    
  methods: {        
    },
  mounted() {            
  },
  name: "ISAHelpModalContent"
}
</script>

<style lang="scss" scoped>
h1 {
  font-weight: 700;
}

.modal-title {
  font-weight: 700;
}

</style>
